export default __webpack_public_path__ + "src/assets/ant-logo.bc3d79c395a1e4ba4b0b028865d40741.png";